import api from "../api";
import {iniciarRequisicao, logout} from "../../helpers";
import {STATUS_HTTP} from "../statusHTTP";

const  PREFIXO = '/compras/materia-prima';

export const buscarTotalizadorCategoriasCompra = async (params) => {
  const url = `${PREFIXO}/totalizador`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.total;
}

export const buscarCategoriasCompra = async (params) => {
  const url = `${PREFIXO}/categorias`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.categorias;
}

export const buscarProdutosCategoriaCompra = async (params) => {
  const url = `${PREFIXO}/categorias/produtos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.produtos;
}

export const buscarQtdCategoriasEmGatilhoDeCompra = async (params) => {
  return await ajudanteBuscarTotalCategorias(params, "categorias-em-gatilho-de-compra");
}

export const buscarQtdCategoriasEmCompletarCompra = async (params) => {
  return await ajudanteBuscarTotalCategorias(params, "categorias-em-completar-compra");
}

export const buscarQtdGeralDeCategorias = async (params) => {
  return await ajudanteBuscarTotalCategorias(params, "categorias");
}

export const buscarQtdCategoriasEmTransito = async (params) => {
  return await ajudanteBuscarTotalCategorias(params, "categorias-em-transito");
}

const ajudanteBuscarTotalCategorias = async (params, uri) => {
  const {data, status} = await api.get(`${PREFIXO}/quantidades/${uri}`, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return parseInt(data.qtd_categorias);
}

export const adicionarCategoriaNoCarrinho = async (requisicao) => {
  const {data, status} = await api.post('/pedidos-compra/materia-prima/categorias-mp', requisicao, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.pedidos;
  }

  logout();
}

export const movimentacoesCategorias = async (parametros) => {
  const { data, status } = await api.post(`${PREFIXO}/indicador-movimentacoes`, parametros, { headers: iniciarRequisicao() })
    .catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data;
  }

  logout();
}

export const movimentacoesCategoria = async (params) => {
  const config = {
    headers: iniciarRequisicao(),
    params
  };

  const url = `${PREFIXO}/categoria/indicador-movimentacoes`;

  const { data, status } = await api.get(url, config).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.movimentacoes;
}

export const buscarDetalhesCategoria = async (params) => {
  const config = {
    headers: iniciarRequisicao(),
    params
  };

  const url = `${PREFIXO}/categoria/detalhamento`;

  const { data, status } = await api.get(url, config).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.detalhamento;
}

export const alterarTempoRessuprimento = async (parametros) => {
  let url = `${PREFIXO}/categoria/tempo-ressuprimento`;

  const { status, data } = await api.post(url, parametros, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return true;
}

export const alterarLoteMinimo = async (parametros) => {
  let url = `${PREFIXO}/categoria/lote-minimo`

  const { status, data } = await api.post(url, parametros, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return true;
}

export const salvarCoberturaManual = async (parametros) => {
  let url = `${PREFIXO}/categoria/cobertura-manual`

  const { status, data } = await api.post(url, parametros, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return true;
}

export const salvarPrevisaoGatilho = async (parametros) => {
  let url = `${PREFIXO}/categoria/previsao-gatilho`

  const { status, data } = await api.post(url, parametros, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return true;
}

export const buscarCaracteristicas = async (parametros) => {
  const url = `${PREFIXO}/categoria/caracteristicas`;

  const {data, status} = await api.post(url, parametros, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  return data.caracteristicas;
}

export const buscarPedidoAbertoDepartamento = async (grupo) => {
  const config = {
    params: { grupo },
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get('/pedidos-compra/materia-prima/aberto', config).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.pedido;
}

export const buscarTotalizadorCategoriasPedidoCompraMateriaPrima = async (id_pedido) => {
  const config = {
    params: { id_pedido },
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get('/pedidos-compra/materia-prima/categorias-mp/totalizador', config).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.total;
}

export const buscarCategoriasPedidoCompraMateriaPrima = async (id_pedido) => {
  const config = {
    params: { id_pedido },
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get('/pedidos-compra/materia-prima/categorias-mp', config).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.categorias;
}

export const editarCategoriaNoPedido = async (requisicao) => {
  const config = {
    headers: iniciarRequisicao()
  };

  const url = '/pedidos-compra/materia-prima/categorias-mp';

  const {data, status} = await api.put(url, requisicao, config).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.resultado;
}

export const excluirCategoriaDoPedido = async (params) => {
  const url = '/pedidos-compra/materia-prima/categorias-mp/exclusao';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.resultado;
}

export const buscarFornecedoresCotacao = async (id_pedido) => {
  const config = {
    headers: iniciarRequisicao(),
    params: { id_pedido }
  };

  const {data, status} = await api.get('/pedidos-compra/materia-prima/fornecedores/cotacao', config).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.fornecedores;
}

export const buscarCategoriasFornecedorCotacao = async (id_pedido, id_fornecedor) => {
  const config = {
    headers: iniciarRequisicao(),
    params: { id_pedido, id_fornecedor }
  };

  const {data, status} = await api.get('/pedidos-compra/materia-prima/fornecedores/cotacao/categorias', config).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.categorias;
}

export const buscarConfiguracoesGeralCategoria = async () => {
  const {data, status} = await api.get(`/compras/materia-prima/configuracao`, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.config;
}

export const salvarConfiguracoesCategorias = async (requisicao) => {
  const {data, status} = await api.post('/compras/materia-prima/configuracao', requisicao, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return true;
}

export const buscarUltimasVendasMensais = async (params) => {
  const config = { params, headers: iniciarRequisicao() };
  const {data, status} = await api.get('/compras/materia-prima/vendas-mensal', config).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.vendas;
}

export const buscarEstoqueCategoria = async (params) => {
  const config = { params, headers: iniciarRequisicao() };
  const {data, status} = await api.get('/compras/materia-prima/categoria/estoque-por-filial', config).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.estoques;
}

export const buscarProdutosCategoria = async (params) => {
  const config = { params, headers: iniciarRequisicao() };
  const {data, status} = await api.get('/compras/materia-prima/categoria/produtos', config).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.produtos;
}

export const buscarCategoriasMPPA = async (params) => {
  const config = { params, headers: iniciarRequisicao() };
  const {data, status} = await api.get('/compras/materia-prima/lista-categorias', config).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.categorias;
}
